import { render } from "./ErrorNotification.vue?vue&type=template&id=30e32a98&scoped=true&ts=true"
import script from "./ErrorNotification.vue?vue&type=script&lang=ts"
export * from "./ErrorNotification.vue?vue&type=script&lang=ts"

import "./ErrorNotification.vue?vue&type=style&index=0&id=30e32a98&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e32a98"]])

export default __exports__